/* tslint:disable */
/* eslint-disable */
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";

import * as Types from "../../generated/types";

const defaultOptions = {} as const;
export type AccountDetailsFragment = {
  __typename: "Account";
  email: string | null;
  firstName: string | null;
  languages: Array<string | null> | null;
  lastName: string | null;
  preferredLanguage: string | null;
  profilePicture: string | null;
  uuid: string | null;
  viewedModals: Array<string | null> | null;
  insertedAt: any | null;
};

export type OrganisationAccountDetailsFragment = {
  __typename: "OrganisationAccount";
  isAdmin: boolean | null;
  role: Types.RoleType | null;
  account: ({ __typename: "Account" } & AccountDetailsFragment) | null;
};

export type GetUiAccountPreferencesQueryVariables = Types.Exact<{
  numberUuid: Types.Scalars["ID"];
  accountUuid: Types.Scalars["ID"];
}>;

export type GetUiAccountPreferencesQuery = {
  __typename: "RootQueryType";
  uiAccountPreferences: {
    __typename: "UiAccountPreferences";
    numberUuid: string | null;
    accountUuid: string | null;
    inboxUseLivebox: boolean | null;
  } | null;
};

export type SetUiAccountPreferenceMutationVariables = Types.Exact<{
  numberUuid: Types.Scalars["ID"];
  accountUuid: Types.Scalars["ID"];
  preferences: Types.UiAccountPreferencesInput;
}>;

export type SetUiAccountPreferenceMutation = {
  __typename: "RootMutationType";
  upsertUiAccountPreference: {
    __typename: "UiAccountPreferences";
    numberUuid: string | null;
    accountUuid: string | null;
    inboxUseLivebox: boolean | null;
  } | null;
};

export const AccountDetailsFragmentDoc = gql`
  fragment AccountDetails on Account {
    email
    firstName
    languages
    lastName
    preferredLanguage
    profilePicture
    uuid
    viewedModals
    insertedAt
  }
`;
export const OrganisationAccountDetailsFragmentDoc = gql`
  fragment OrganisationAccountDetails on OrganisationAccount {
    isAdmin
    role
    account {
      ...AccountDetails
    }
  }
  ${AccountDetailsFragmentDoc}
`;
export const GetUiAccountPreferencesDocument = gql`
  query GetUiAccountPreferences($numberUuid: ID!, $accountUuid: ID!) {
    uiAccountPreferences(numberUuid: $numberUuid, accountUuid: $accountUuid) {
      numberUuid
      accountUuid
      inboxUseLivebox
    }
  }
`;

/**
 * __useGetUiAccountPreferencesQuery__
 *
 * To run a query within a React component, call `useGetUiAccountPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUiAccountPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUiAccountPreferencesQuery({
 *   variables: {
 *      numberUuid: // value for 'numberUuid'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useGetUiAccountPreferencesQuery(
  baseOptions: Apollo.QueryHookOptions<GetUiAccountPreferencesQuery, GetUiAccountPreferencesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUiAccountPreferencesQuery, GetUiAccountPreferencesQueryVariables>(
    GetUiAccountPreferencesDocument,
    options
  );
}
export function useGetUiAccountPreferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUiAccountPreferencesQuery, GetUiAccountPreferencesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUiAccountPreferencesQuery, GetUiAccountPreferencesQueryVariables>(
    GetUiAccountPreferencesDocument,
    options
  );
}
export type GetUiAccountPreferencesQueryHookResult = ReturnType<typeof useGetUiAccountPreferencesQuery>;
export type GetUiAccountPreferencesLazyQueryHookResult = ReturnType<typeof useGetUiAccountPreferencesLazyQuery>;
export type GetUiAccountPreferencesQueryResult = Apollo.QueryResult<
  GetUiAccountPreferencesQuery,
  GetUiAccountPreferencesQueryVariables
>;
export const SetUiAccountPreferenceDocument = gql`
  mutation SetUiAccountPreference($numberUuid: ID!, $accountUuid: ID!, $preferences: UiAccountPreferencesInput!) {
    upsertUiAccountPreference(numberUuid: $numberUuid, accountUuid: $accountUuid, preferences: $preferences) {
      numberUuid
      accountUuid
      inboxUseLivebox
    }
  }
`;
export type SetUiAccountPreferenceMutationFn = Apollo.MutationFunction<
  SetUiAccountPreferenceMutation,
  SetUiAccountPreferenceMutationVariables
>;

/**
 * __useSetUiAccountPreferenceMutation__
 *
 * To run a mutation, you first call `useSetUiAccountPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUiAccountPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUiAccountPreferenceMutation, { data, loading, error }] = useSetUiAccountPreferenceMutation({
 *   variables: {
 *      numberUuid: // value for 'numberUuid'
 *      accountUuid: // value for 'accountUuid'
 *      preferences: // value for 'preferences'
 *   },
 * });
 */
export function useSetUiAccountPreferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<SetUiAccountPreferenceMutation, SetUiAccountPreferenceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetUiAccountPreferenceMutation, SetUiAccountPreferenceMutationVariables>(
    SetUiAccountPreferenceDocument,
    options
  );
}
export type SetUiAccountPreferenceMutationHookResult = ReturnType<typeof useSetUiAccountPreferenceMutation>;
export type SetUiAccountPreferenceMutationResult = Apollo.MutationResult<SetUiAccountPreferenceMutation>;
export type SetUiAccountPreferenceMutationOptions = Apollo.BaseMutationOptions<
  SetUiAccountPreferenceMutation,
  SetUiAccountPreferenceMutationVariables
>;
